import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction, useEditOrderSvc } from '../service'

import { useForm } from 'react-hook-form'

export function ChangeCharge(props: {
  onClose: () => void
  onSave: (action: EditOrderAction) => void
  charge_id: number
}): JSX.Element {
  const editOrderSvc = useEditOrderSvc()
  const charge = editOrderSvc.getServiceCharge(props.charge_id)
  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      amount: charge.amount,
    },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any) => {
    props.onSave({
      op: 'update-charge',
      charge_id: props.charge_id,
      charge: { ...charge, amount: data.amount },
      value: data.amount,
      prev_value: charge.amount,
    })
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Change Charge</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="amount">Amount:</label>
            <input
              id="amount"
              className="form-control input input-small"
              style={errors && errors.amount ? { color: 'red' } : {}}
              type="number"
              step={0.01}
              {...register('amount', {
                required: 'is required',
                min: { value: 0.01, message: 'must be greater than 0' },
                valueAsNumber: true,
              })}
            />
            {errors && errors.amount && <span className="text-danger">{errors.amount.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Save
          </Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
